module.exports = __webpack_public_path__ + "img/sinimagen.45b105be.jpeg";